const getVisibleEquipmentsByTruckDriverIDUsecase = (repository) => async (id) => {
    return await repository(id);
}

export default getVisibleEquipmentsByTruckDriverIDUsecase;